var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineaCurvaSiteMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1456,
    height: 103,
    viewBox: "0 0 1456 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 55.7101C1 55.7101 373.788 80.5457 685 15.7101C973 -44.2899 1455 101.71 1455 101.71",
    stroke: "url(#paint0_linear_1765_196)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1765_196",
    x1: -657.23,
    y1: 1303.5,
    x2: 1534.78,
    y2: 22.7329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#58C787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaCurvaSiteMap);
export default __webpack_public_path__ + "static/media/LineaCurvaSiteMap.baccf72a79abc955bc0808c1ae8e3c8b.svg";
export { ForwardRef as ReactComponent };